export const base = {
  black: "var(--black)",
  darkgrey: "var(--darkgrey)",
  darkbrown: "var(--darkbrown)",
  grey: "var(--grey)",
  greyalt: "var(--grey-alt)",
  lightgrey: "var(--lightgrey)",
  offwhite: "var(--offwhite)",
  white: "var(--white)",
};

export const system = {
  activeblue: "var(--activeblue)",
  alertred: "var(--alertred)",
  bordergrey: "var(--bordergrey)",
};

export const green = {
  green4: "var(--green4)",
  green5: "var(--green5)",
  green6: "var(--green6)",
  green7: "var(--green7)",
};

export const eggshell = {
  eggshell4: "var(--eggshell4)",
  eggshell5: "var(--eggshell5)",
  eggshell6: "var(--eggshell6)",
  eggshell7: "var(--eggshell7)",
};

export const peach = {
  peach4: "var(--peach4)",
  peach5: "var(--peach5)",
  peach6: "var(--peach6)",
  peach7: "var(--peach7)",
};

export const lightazure = {
  lightazure4: "var(--lightazure4)",
  lightazure5: "var(--lightazure5)",
  lightazure6: "var(--lightazure6)",
  lightazure7: "var(--lightazure7)",
};

export const steelblue = {
  steelblue4: "var(--steelblue4)",
  steelblue5: "var(--steelblue5)",
  steelblue6: "var(--steelblue6)",
  steelblue7: "var(--steelblue7)",
};

export const slate = {
  slate4: "var(--slate4)",
  slate5: "var(--slate5)",
  slate6: "var(--slate6)",
  slate7: "var(--slate7)",
};

export default {
  ...base,
  ...system,
  ...green,
  ...eggshell,
  ...peach,
  ...lightazure,
  ...steelblue,
  ...slate,
};
